import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleMenu (state, action) {
      const { referrence, value } = action.payload
      const newState = { ...state }
      newState[referrence] = value
      return newState
    }
  }
})

export const { toggleMenu } = menu.actions
export const MenuReducer = menu.reducer
